(function () {
  'use strict';

  /* @ngdoc object
   * @name createPairing
   * @description
   *
   */
  angular
    .module('createPairing', [
      'ui.router'
    ]);
}());
